module.exports = __webpack_public_path__ + "static/fonts/DigitaldreamFatNarrow.3f36d49.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/comment/font/DigitaldreamFatNarrow.ttf
// module id = 8qCK
// module chunks = 133